import { Box, Grid } from '@mui/material'
import React from 'react'
import { Linker } from 'src/Components/Ui/Linker'
import { ImageButton } from 'src/Components/Ui/ImageButton'
import { useLocale } from 'src/locales/useLocale'

const US_GLOVE_PATH = '/hard/atoms/us/glove'

const Brands: React.FC = () => {
  const { t, isEn, isKo, isJa, isZhTw, isForeign } = useLocale()

  return (
    <Box>
      <Box py={2} data-testid={'brand-selection-page'}>
        {t.BRAND_SELECTION_PAGE}
      </Box>
      {/* <Box py={8} display={'flex'} justifyContent={'space-around'}> */}
      <Box py={8} display={'flex'}>
        <Grid container justifyContent={'center'}>
          {isForeign && (
            <>
              <Grid item>
                <Box p={2}>
                  <Linker href={US_GLOVE_PATH}>
                    <ImageButton label={t.BRAND_SELECTION_PAGE_HEADLINE_US_MODEL} srcUrl={'/brandsSelect/usAtomsButton.jpg'} alt={'hard-usGlove'} />
                  </Linker>
                </Box>
              </Grid>
              <Grid item>
                <Box p={2}>
                  <Linker href={'/hard/atoms/japan'}>
                    <ImageButton label={t.BRAND_SELECTION_PAGE_HEADLINE_JAPAN_MODEL} srcUrl={'/brandsSelect/atomsButton.jpg'} alt={'hard-atoms'} />
                  </Linker>
                </Box>
              </Grid>
              {/* {isZhTw && (
                <Grid item>
                  <Box p={2}>
                    <Linker href={'/hard/yellStory'}>
                      <ImageButton label={'Yell-story'} srcUrl={'/brandsSelect/ysrButton.jpg'} alt={'hard-ysr'} disabled={isEn || isKo} />
                    </Linker>
                  </Box>
                </Grid>
              )} */}
            </>
          )}
          {isJa && (
            <>
              <Grid item>
                <Box p={2}>
                  <Linker href={'/hard/atoms/japan'}>
                    <ImageButton label={'ATOMS'} srcUrl={'/brandsSelect/atomsButton.jpg'} alt={'hard-atoms'} />
                  </Linker>
                </Box>
              </Grid>
              <Grid item>
                <Box p={2}>
                  <Linker href={'/hard/yellStory'}>
                    <ImageButton label={'Yell-story'} srcUrl={'/brandsSelect/ysrButton.jpg'} alt={'hard-ysr'} disabled={isEn || isKo} />
                  </Linker>
                </Box>
              </Grid>
              <Grid item>
                <Box p={2}>
                  <Linker href={'/hard/dxm'}>
                    <ImageButton label={'D x M(ディーバイエム)'} srcUrl={'/brandsSelect/dxmButton.jpg'} alt={'hard-dxm'} disabled={isEn || isKo} />
                  </Linker>
                </Box>
              </Grid>
              <Grid item>
                <Box p={2}>
                  <Linker href={'/hard/gorilla'}>
                    <ImageButton
                      label={'ごりら印の野球道具'}
                      srcUrl={'/brandsSelect/gorillaButton.jpg'}
                      alt={'hard-gorilla'}
                      disabled={isEn || isKo}
                    />
                  </Linker>
                </Box>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </Box>
  )
}

export default Brands
